export default __webpack_public_path__ + "static/media/lung1.48f36cd4.jpg";